/* Nimbus acquisition-funnel instrumentation. See snippets/nimbus-funnel.liquid and
   planning/analytics/FUNNEL-INSTRUMENTATION-2026-10-25.md. Carries ONLY non-personal context. */
(function () {
  var cfg = window.NimbusFunnel || {};
  var PORTAL_HOSTS = /(^|\.)(b2b|bwg)\.nimbusdistributions\.com$/i;
  var KEY = 'nimbusLanding';

  function landing() {
    var l = null;
    try { l = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { l = null; }
    if (l) return l;
    var q = new URLSearchParams(location.search);
    l = { lp: location.pathname, ref: (document.referrer || '').split('/').slice(0, 3).join('/') };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid'].forEach(function (k) {
      var v = q.get(k); if (v) l[k] = String(v).slice(0, 80);
    });
    try { sessionStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {}
    return l;
  }

  function routeOf(url) {
    var m = /[?&]route=([a-z]+)/i.exec(url.search || '');
    if (m) return m[1].toLowerCase();
    if (/bwg\./i.test(url.hostname) || /#bwg/.test(url.hash)) return 'bwg';
    if (/#musgrave/.test(url.hash)) return 'musgrave';
    if (/b2b\./i.test(url.hostname) || /#direct/.test(url.hash)) return 'direct';
    return '';
  }

  function context(url) {
    var l = landing(), route = routeOf(url);
    var c = { src: 'www', lp: l.lp || '', page_type: cfg.pageType || '', resource: cfg.resource || '' };
    if (route) c.route = route;
    if (cfg.brand) c.brand = cfg.brand;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'ref'].forEach(function (k) { if (l[k]) c[k] = l[k]; });
    return c;
  }

  function decorate(a) {
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
    if (!PORTAL_HOSTS.test(url.hostname)) return;
    if (url.searchParams.get('src')) return;
    var c = context(url);
    ['src', 'lp', 'brand', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid'].forEach(function (k) {
      if (c[k]) url.searchParams.set(k, c[k]);
    });
    if (c.route && !url.searchParams.get('route')) url.searchParams.set('route', c.route);
    a.setAttribute('href', url.toString());
  }

  function publish(name, payload) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, payload)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload); } catch (e) {}
  }

  function isRegister(url) { return /\/pages\/register/.test(url.pathname) || (PORTAL_HOSTS.test(url.hostname) && /register/.test(url.pathname)); }
  function isPortal(url) { return /\/pages\/order-portals/.test(url.pathname) || (PORTAL_HOSTS.test(url.hostname) && !/register/.test(url.pathname)); }

  function init() {
    landing();
    document.querySelectorAll('a[href]').forEach(decorate);
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var url; try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
      var c = context(url);
      c.cta = (a.className || '').toString().split(' ').filter(function (x) { return /^nimbus-/.test(x); }).slice(0, 2).join(' ');
      c.label = (a.textContent || '').trim().slice(0, 60);
      if (isRegister(url)) {
        c.step = PORTAL_HOSTS.test(url.hostname) ? 'route_selected' : 'register_click';
        publish('nimbus_register_click', c);
      } else if (isPortal(url)) {
        publish('nimbus_portal_click', c);
      }
    }, true);
    // Hero "Find products" search = a navigation step worth counting (no query text is sent).
    document.querySelectorAll('form[role="search"]').forEach(function (f) {
      f.addEventListener('submit', function () { publish('nimbus_site_search', { page_type: cfg.pageType || '', lp: landing().lp || '' }); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
